<template>
  <div class="payment-packages">
    <vue-custom-scrollbar
      class="scroll-area calcHeight scroll-area--mb"
      :settings="{
        maxScrollbarLength: 60,
        swipeEasing: true,
        suppressScrollY: false
      }"
    >
      <div class="payment-packages__wrap">
        <component
          :is="schoolComponentName"
          :student="student"
        />



        <div class="container-fluid payment-packages__total">
            <!--div v-if="getStudentSluhach && getSchoolId" class="div_form_set_sluhach">
                <form action="https://cdo.org.ua/reg/set_sluhach.php" method="POST">
                    <input type="hidden" name="user_id"
                           :value="student.id">
                    <input type="hidden" name="g_class"
                        :value="getClss">
                    <input type="hidden" name="school_id"
                        :value="getSchoolId">
                    <input type="submit" value="Зарахувати як слухач" class="button button--accent button--add">
                </form>
            </div-->
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>{{ $t('package') }}</th>
                <th>{{ $t('subscription_amount') }}</th>
                <th>{{ $t('paid') }}</th>
                <th>{{ $t('remainder') }}</th>
                <th>{{ $t('month_amount') }}</th>
              </tr>
            </thead>
            <tbody>
              <student-payment-package
                v-for="item of packages"
                :key="item.id"
                :item="item"
              />
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4">
                  <b>{{ $t('total_pay') }}</b>
                </td>
                <td>{{ totalSum | money }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import env from '../../env';
import StudentPaymentPackage from './StudentPaymentPackage';

const modulesFiles = require.context('./payment-details', true, /\.vue$/);

const schoolComponents = modulesFiles.keys().reduce((accumulator, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  accumulator[moduleName] = value.default;
  return accumulator;
}, {});

export default {
  props: ['student_id'],
  components: {
    vueCustomScrollbar,
    StudentPaymentPackage,
    ...schoolComponents,
  },
  data() {
    return {
      env,
      schoolId: window.school_id || 'default',
    };
  },
  computed: {
    ...mapGetters(['subscriptions_payer', 'student']),
    packages() {
      return this.subscriptions_payer.results &&
        this.subscriptions_payer.results.length > 0
        ? this.subscriptions_payer.results
        : false;
    },
    getStudentSluhach() {
		if(this.packages[1]){
            if(this.packages[1].subscription_contract && this.packages[1].subscription_contract.name == 'Слухач Літо'){
                return false;
            }
        }
		if(this.packages[0]){
            if(this.packages[0].subscription_contract && this.packages[0].subscription_contract.name == 'Слухач Літо'){
                return false;
            }
			if(this.packages[0].start_at && this.packages[0].start_at == '2021-09-01'){
				console.log(this.packages[0]);
				return true;
			}
		}
		return false;
    },
	getClss() {
		if(this.packages[0]){
			if(this.packages[0].start_at && this.packages[0].start_at == '2021-09-01'){
				return (this.packages[0].packages[0].group.g_class-1);
			}
		}
		return 10;
	},
    getSchoolId() {
      if (this.schoolId === undefined) {
        return false;
      }
	  return this.schoolId;
    },
    totalSum() {
      return this.subscriptions_payer && this.subscriptions_payer.total_sum
        ? this.subscriptions_payer.total_sum
        : 0;
    },
    schoolComponentName() {
      if (this.schoolId === undefined) {
        return 'School_default';
      }

      const componentName = `School_${this.schoolId}`;

      console.log(componentName);

      if (this.$options.components[componentName] === undefined) {
        return 'School_default';
      }
      
      console.log('add', componentName);

      return componentName;
    },
  },
  methods: {
    getPayedTotal(item) {
      return item.payed_total ? item.payed_total : '0.00';
    },
  },
};
</script>

<style lang="sass">
@import "../../../sass/variables"

.payment-packages
  padding: 20px 0
  
  &__total
    margin-top: 25px

  &__alert
    color: $red-j
    font-size: 14px
    margin-top: 10px
    margin-bottom: 30px

.video
  position: relative
  width: 100%
  padding-bottom: 56.25%

  iframe
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%

.col-md-6
  margin-top: 15px
  margin-bottom: 15px

.table
  margin-bottom: 0
  font-size: 14px
  color: $black-j

  td,
  th
    vertical-align: top
    padding: 5px 10px
    font-weight: 500

  th,
  tfoot > tr > td
    color: $black-j

.scroll-area
  position: relative

</style>
